import { ranking } from "@/mocks/ranking";
import SectionHeading from "./SectionHeading";

const trendMap: Record<string, { icon: string; text: string; className: string }> = {
  up: { icon: "ri-arrow-up-line", text: "升温", className: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", text: "降温", className: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", text: "持平", className: "text-foreground-500" },
};

export default function RankingSection() {
  const maxHeat = ranking[0].heat;

  return (
    <section id="ranking" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20">
      <div className="w-full">
        <SectionHeading
          eyebrow="热度榜"
          title="近期讨论最集中的 8 个事件"
          desc="热度由站内阅读量、搜索词与讨论量综合得出，每天更新一次。排名变化本身，往往也能反映事件的最新走向。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6 lg:gap-8">
          <ol className="rounded-lg border border-background-200 bg-background-50 divide-y divide-background-100 overflow-hidden">
            {ranking.map((item) => {
              const trend = trendMap[item.trend];
              return (
                <li
                  key={item.rank}
                  className="flex items-center gap-3 md:gap-4 p-4 md:p-5 hover:bg-background-100/70 transition-colors cursor-pointer"
                >
                  <span
                    className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md font-heading font-bold text-sm ${
                      item.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base truncate">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-[11px] text-secondary-700 bg-secondary-100 px-2 py-0.5 rounded">
                        {item.category}
                      </span>
                      <span className={`inline-flex items-center gap-0.5 text-[11px] font-medium ${trend.className}`}>
                        <i className={trend.icon} />
                        {trend.text}
                      </span>
                    </div>
                  </div>
                  <span className="hidden sm:flex flex-col items-end gap-1 w-28 shrink-0">
                    <span className="text-sm font-medium text-foreground-800">{item.heat}</span>
                    <span className="w-full h-1.5 rounded-full bg-background-200 overflow-hidden">
                      <span
                        className="block h-full rounded-full bg-accent-500"
                        style={{ width: `${(item.heat / maxHeat) * 100}%` }}
                      />
                    </span>
                  </span>
                </li>
              );
            })}
          </ol>

          <aside className="rounded-lg border border-secondary-300 bg-secondary-50 p-5 md:p-6 self-start">
            <span className="inline-flex w-11 h-11 items-center justify-center rounded-md bg-secondary-500 text-background-50 text-xl mb-4">
              <i className="ri-lightbulb-line" />
            </span>
            <h3 className="font-heading font-bold text-foreground-950 text-lg mb-3">怎么看懂一张热度榜</h3>
            <ul className="space-y-3 text-sm text-foreground-700 leading-relaxed">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-fill text-secondary-600 mt-0.5" />
                排名靠前说明讨论量大，但不等于结论已经明确。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-fill text-secondary-600 mt-0.5" />
                「升温」多为出现新进展或新回应，适合优先补课。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-fill text-secondary-600 mt-0.5" />
                「降温」代表讨论自然回落，通常可以对照时间线做完整复盘。
              </li>
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}